import socket from '@/services/socket.js'

export default {
  /**
   * Get videos watched on YouTube.
   *
   * @param user_id
   * @param min_date
   * @param max_date
   * @returns Promise
   */
  getViews(user_id, min_date, max_date) {
    const action = '/user/youtube/get'
  
    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        user_id,
        body: {
          min_date,
          max_date
        }
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }
  
        resolve(data.youtube_data)
      })
    })
  },

  /**
   * Update watched on YouTube video data.
   *
   * @param events
   * @returns Promise
   */
  updateViews(events) {
    const action = '/youtube/update'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        events
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data)
      })
    })
  }
}